import {Component} from '@angular/core';
import {ESubscriptionIssue} from "../../enums/subscription-issue.enum";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService} from "../../../../../../kernel/tools/message/service/message.service";
import {
  ISubscriptionRejectionReason,
  ISubscriptionRejectionReasonValue
} from "../../interfaces/reject-subscription-reason.interface";


@Component({
  selector: 'app-reject-subscription-popup',
  templateUrl: './reject-subscription-popup.component.html',
  styleUrls: ['./reject-subscription-popup.component.scss']
})
export class RejectSubscriptionPopupComponent {

  constructor(
    private ref: DynamicDialogRef,
    private messageService: MessageService
  ) {
  }

  reasons: ISubscriptionRejectionReasonValue[] = Object.values(ESubscriptionIssue).map(issue => ({
    issue,
    selected: false,
  }));

  getValue(): ISubscriptionRejectionReason[] {
    return this.getSelectedReasons().map(r => this.formatValue(r));
  }

  private getSelectedReasons(): ISubscriptionRejectionReasonValue[] {
    return this.reasons.filter(r => r.selected);
  }

  private formatValue(reason: ISubscriptionRejectionReasonValue): ISubscriptionRejectionReason {
    return {issue: reason.issue, otherDetails: reason.otherDetails}
  }

  close(value?: ISubscriptionRejectionReason[]) {
    this.ref.close(value);
  }

  reject() {
    const value = this.getValue()
    if (!value?.length) {
      this.messageService.error('You should select at least one reason!.') ;
      return ;
    }
    this.close(value);
  }

  protected readonly ESubscriptionIssue = ESubscriptionIssue;
}
